import classNames from 'classnames';
import React, { useState } from 'react';
import { Link } from '../utils/router/v3Bridge';
import IconButton from '../components/IconButton';
import OverflowMenu from '../components/OverflowMenu';
import SVGIcon from '../components/SVGIcon';
import styles from './GroupChildCard.module.scss';
import overflowMenuIcon from '../icons/non-prefilled/16x16/overflowMenu.svg';

interface GroupChildCardProps {
  avatars?: React.ReactNode;
  badge?: React.ReactNode;
  title?: React.ReactNode;
  description?: string | null;
  to: string;
  menuItems?: React.ReactNode;
}

const GroupChildCard = ({
  avatars = null,
  badge = null,
  title,
  description,
  to,
  menuItems,
}: GroupChildCardProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className={styles.card}>
      <Link to={to} className={styles.content}>
        {!!avatars && (
          <div className={styles.avatarsContainer}>
            {avatars}
            {!!badge && <div className={styles.badgeContainer}>{badge}</div>}
          </div>
        )}
        <div className={styles.title}>{title}</div>
        {description && <div className={styles.description}>{description}</div>}
      </Link>
      {!!menuItems && (
        <div
          className={classNames(styles.menuContainer, {
            [styles.open]: isMenuOpen,
          })}
        >
          <OverflowMenu
            iconSize="regular"
            open={isMenuOpen}
            onOpenChange={setIsMenuOpen}
            placement="top-end"
            button={
              <IconButton
                active={isMenuOpen}
                className={styles.overflowButton}
                size="small"
                aria-label="More options"
              >
                <SVGIcon size="small">{overflowMenuIcon}</SVGIcon>
              </IconButton>
            }
          >
            {menuItems}
          </OverflowMenu>
        </div>
      )}
    </div>
  );
};

export default GroupChildCard;
